import { formatLocation } from './formatters';

export type SortedJobsType = {
  [name: string]: {
    jobs: Array<Job>;
    location: JobLocation;
    displayName: string;
  };
};

export const groupJobsByLocation = (jobs: Array<Job>): SortedJobsType => {
  const jobsByLocation: SortedJobsType = {};

  jobs.forEach((job) => {
    // capitalize all location keys for case insensitive key comparison
    const location =
      formatLocation({ city: job.city, state: job.state })?.toUpperCase() || 'UNKNOWN';
    const locationDisplay = formatLocation({ city: job.city, state: job.state }) || 'Unknown';

    // check to see if there's already been a job with that location. If not, add it.
    if (jobsByLocation[location]) {
      jobsByLocation[location].jobs.push(job);
    } else {
      jobsByLocation[location] = {
        jobs: [job],
        location: {
          city: job.city,
          state: job.state,
          officeCity: job.officeCity,
          officeState: job.officeState,
          officeStreet: job.officeStreet,
          officeUnit: job.officeUnit,
          officeZipCode: job.officeZipCode,
        },
        displayName: locationDisplay,
      };
    }
  });

  return sortJobLocations(jobsByLocation);
};

export const sortJobLocations = (jobsByLocation: SortedJobsType) => {
  const sorted: SortedJobsType = {};
  Object.keys(jobsByLocation)
    .sort()
    .forEach((key) => {
      sorted[key] = jobsByLocation[key];
    });

  return sorted;
};
